import { colorPrimary100, colorPrimary200, colorPrimary300, colorPrimary400, colorPrimary500, colorPrimary600, colorPrimary700, colorPrimary800, colorPrimary900, colorSecondary100, colorSecondary200, colorSecondary300, colorSecondary400, colorSecondary500, colorSecondary600, colorSecondary700, colorSecondary800, colorSecondary900, colorGreyscale100, colorGreyscale200, colorGreyscale300, colorGreyscale400, colorGreyscale500, colorGreyscale600, colorGreyscale700, colorGreyscale800, colorGreyscale900, colorSuccess100, colorSuccess200, colorSuccess300, colorSuccess400, colorSuccess500, colorSuccess600, colorSuccess700, colorSuccess800, colorSuccess900, colorWarning100, colorWarning200, colorWarning300, colorWarning400, colorWarning500, colorWarning600, colorWarning700, colorWarning800, colorWarning900, colorDanger100, colorDanger200, colorDanger300, colorDanger400, colorDanger500, colorDanger600, colorDanger700, colorDanger800, colorDanger900, } from "@airhelp/design-tokens";
const colors = {
    font: {
        primary: colorPrimary900,
    },
    primary: {
        100: colorPrimary100,
        200: colorPrimary200,
        300: colorPrimary300,
        400: colorPrimary400,
        500: colorPrimary500,
        600: colorPrimary600,
        700: colorPrimary700,
        800: colorPrimary800,
        900: colorPrimary900,
    },
    secondary: {
        100: colorSecondary100,
        200: colorSecondary200,
        300: colorSecondary300,
        400: colorSecondary400,
        500: colorSecondary500,
        600: colorSecondary600,
        700: colorSecondary700,
        800: colorSecondary800,
        900: colorSecondary900,
    },
    greyscale: {
        100: colorGreyscale100,
        200: colorGreyscale200,
        300: colorGreyscale300,
        400: colorGreyscale400,
        500: colorGreyscale500,
        600: colorGreyscale600,
        700: colorGreyscale700,
        800: colorGreyscale800,
        900: colorGreyscale900,
    },
    success: {
        100: colorSuccess100,
        200: colorSuccess200,
        300: colorSuccess300,
        400: colorSuccess400,
        500: colorSuccess500,
        600: colorSuccess600,
        700: colorSuccess700,
        800: colorSuccess800,
        900: colorSuccess900,
    },
    warning: {
        100: colorWarning100,
        200: colorWarning200,
        300: colorWarning300,
        400: colorWarning400,
        500: colorWarning500,
        600: colorWarning600,
        700: colorWarning700,
        800: colorWarning800,
        900: colorWarning900,
    },
    danger: {
        100: colorDanger100,
        200: colorDanger200,
        300: colorDanger300,
        400: colorDanger400,
        500: colorDanger500,
        600: colorDanger600,
        700: colorDanger700,
        800: colorDanger800,
        900: colorDanger900,
    },
};
export default colors;
